export default class ControlsState extends Phaser.State {
  create () {
    this.add.bitmapText(16, 16, 'monospace', 'CONTROLS', 9)

    this.menuItems = [
      this.add.bitmapText(16, 50, 'monospace', 'W A S D : MOVE', 9),
      this.add.bitmapText(16, 62, 'monospace', 'Q E     : CYCLE TOOLS', 9),
      this.add.bitmapText(16, 74, 'monospace', '0 TO 9  : PICK TOOL', 9),
      this.add.bitmapText(16, 86, 'monospace', 'ENTER   : USE TOOL', 9),
      this.add.bitmapText(16, 98, 'monospace', 'SHIFT   : SHOW TILE HEX', 9),
      this.add.bitmapText(16, 110, 'monospace', 'R       : RESTART LEVEL', 9)
    ]

    const onEnter = () => {
      this.state.start('init', true, false, 0)
    }

    const enterKey = this.game.input.keyboard.addKey(Phaser.Keyboard.ENTER)
    enterKey.onDown.add(() => { onEnter() })
    const mKey = this.game.input.keyboard.addKey(Phaser.Keyboard.M)
    mKey.onDown.add(() => { onEnter() })
    const escapeKey = this.game.input.keyboard.addKey(Phaser.Keyboard.ESC)
    escapeKey.onDown.add(() => { onEnter() })
  }
}
